"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkAnalysisModuleInclusionTypeSchema = exports.NetworkAnalysisModuleInclusionType = void 0;
const zod_1 = require("zod");
var NetworkAnalysisModuleInclusionType;
(function (NetworkAnalysisModuleInclusionType) {
    NetworkAnalysisModuleInclusionType["Full"] = "full";
    NetworkAnalysisModuleInclusionType["Partial"] = "partial";
})(NetworkAnalysisModuleInclusionType || (exports.NetworkAnalysisModuleInclusionType = NetworkAnalysisModuleInclusionType = {}));
exports.NetworkAnalysisModuleInclusionTypeSchema = zod_1.default.nativeEnum(NetworkAnalysisModuleInclusionType);
//# sourceMappingURL=NetworkAnalysisTypes.js.map